module.exports = __webpack_public_path__ + "tractor-new.115a9e92f872097c25c4.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/tractor-new.png
// module id = ../../../../../src/assets/img/tractor-new.png
// module chunks = styles